<template>
	<el-main class="info-wrap">
		<div class="info-box">
			<div v-if="info">
				<div class="info-head tc">
					<h3>{{ info.title }}</h3>
				</div>
				<!--				<div class="info-content" v-html="info.content"></div>-->
				<div class="info-content">
					<p>[特规通-特种设备标准规范智能服务平台]用户协议</p>
					<p>发布日期：[2026年01月01日]</p>
					<p>生效日期：[2026年01月01日]</p>
					<p>
						欢迎您使用[特规通-特种设备标准规范智能服务平台]（以下简称“本平台”）提供的各项服务。本协议是您（以下简称“用户”）与[量大(北京)信息科技研究院有限公司]（以下简称“运营方”）之间就使用本平台服务所订立的具有法律约束力的协议。
					</p>
					<p>
						请您在注册、登录或使用本平台服务前，仔细阅读并充分理解本协议全部条款，特别是关于运营方免责、用户违约责任、知识产权、个人信息保护以及限制或免除责任的条款（相关条款可能以加粗等形式提示）。若您不同意本协议任何内容，请勿使用本平台服务；您一旦注册、登录或使用本平台服务，即视为已充分理解并接受本协议全部条款，自愿与运营方建立服务合同关系。
					</p>
					<p>
						运营方有权根据业务发展、法律法规更新等情况对本协议进行修订，修订后的协议将通过本平台首页公告、弹窗提示等合理方式通知您。若您在协议修订后继续使用本平台服务，即视为接受修订后的协议；若您不同意修订内容，应立即停止使用本平台服务。
					</p>
					<h5>一、服务内容与范围</h5>
					<p>
						1.1
						本平台为用户提供以下核心服务及辅助服务，具体以平台实时展示的功能模块为准：（1）核心服务：内容浏览、内容查询、内容搜索、内容收藏、智能AI问答、商品展示、在线交易、订单管理、物流跟踪、标准查询、信息发布、在线交流、功能使用、数据存储、会员服务等]服务，具体服务范围及功能以本平台实际展示为准。（2）辅助服务：账户注册与管理、实名认证、支付结算、客服咨询、投诉处理、安全保障等。运营方有权根据用户类型（如个人用户、企业用户、付费用户、免费用户）划分服务权限，不同类型用户可使用的服务范围可能存在差异，具体以平台规则公示为准。
					</p>
					<p>1.2 运营方有权根据业务需求对服务内容、功能模块、服务规则等进行调整，调整后将通过前述通知方式告知用户，用户应及时关注相关变更。</p>
					<p>1.3 为保障服务质量，运营方可能会对部分服务设定使用条件、范围或限制，如用户等级、付费门槛等，具体以平台规则为准。</p>
					<h5>二、用户注册与账户管理</h5>
					<p>2.1 注册资格</p>
					<p>用户注册使用本平台服务，需具备完全民事行为能力。若您为无民事行为能力人或限制民事行为能力人，应在法定监护人陪同下阅读本协议，并在监护人同意后使用本平台服务。</p>
					<p>2.2 注册信息</p>
					<p>
						2.2.1
						用户注册时需提供真实、准确、完整的个人信息（如姓名、手机号码、身份证号码等，企业用户需提供营业执照、联系人信息等），并确保信息持续有效。若因用户提供信息虚假、不准确或不完整导致无法使用服务、遭受损失或给第三方造成损害，由用户自行承担责任。
					</p>
					<p>2.2.2 用户注册成功后，将获得唯一的账户及密码，账户所有权归运营方所有，用户仅享有账户使用权，且该使用权不得转让、出租、出借或继承。</p>
					<p>2.3 账号安全</p>
					<p>
						2.3.1
						用户应妥善保管账户密码、验证码等身份验证信息，对账户下的所有操作行为负责。若发现账户被盗用、异常登录等情况，应立即通知运营方并采取修改密码、冻结账户等措施，运营方在收到通知后将根据规则协助处理，但不承担因用户未及时通知或保管不当导致的损失。因用户保管不当等自身原因或其他不可抗因素导致遭受盗号或密码丢失，用户应自行承担相应责任和后果。
					</p>
					<p>2.3.2 用户不得利用账户从事任何违法违规或损害本平台、第三方权益的行为，否则运营方有权根据本协议约定采取封号、冻结账户等措施，由此产生的责任由用户承担。</p>
					<p>2.4 账户注销</p>
					<p>
						用户可根据本平台规定的流程申请注销账户，注销前应确保账户无未完成的交易、未结清的款项或其他未处理的义务。账户注销后，运营方将根据相关法律法规规定处理用户信息，不再为用户提供服务，且已产生的权利义务关系不受影响。
					</p>
					<p>2.5 删除账号</p>
					<p>对于长期未使用（连续12个月及以上无登录记录）且无绑定有效联系方式的账号，管理团队有权根据平台运营需求进行清理，包括但不限于冻结账号、删除账号信息等。</p>
					<h5>三、用户权利与义务</h5>
					<p>3.1 用户权利</p>
				</div>
			</div>
			<el-card v-else class="no-data-box" shadow="never">
				<el-empty description="暂无数据"></el-empty>
			</el-card>
		</div>
	</el-main>
</template>

<script>
	export default {
		props: {
			info: {
				type: Object,
				default: () => {
					return {};
				}
			}
		}
	};
</script>

<style lang="less" scoped>
	.info-wrap {
		margin-left: 20px;
		padding: 20px 0 !important;
		font-size: 14px;
		color: #475569;
		line-height: 1.8;
		background-color: #fff;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
		border-radius: 12px;
		h3 {
			margin: 0 0 10px;
			font-weight: 600;
			font-size: 24px;
			color: #0f172a;
		}
	}
	.info-head {
		margin-bottom: 25px;
		padding-bottom: 15px;
		border-bottom: 1px dashed #e2e8f0;
	}

	.info-content {
        text-indent: 2em;
        padding: 0 30px;
	}

	.info-content p {
		margin: 0;
	}

	.info-content h5 {
		color: #0f172a;
		font-size: 16px;
		margin: 0;
		padding: 0;
		line-height: 34px;
		margin-top: 10px;
	}

	.info-content h6 {
		color: #0f172a;
		font-size: 16px;
		margin: 0;
		padding: 0;
		line-height: 34px;
		position: relative;
	}
	.info-content h6:before {
		content: ' ';
		display: inline-block;
		width: 5px;
		height: 5px;
		background: #155dfc;
		border-radius: 50%;
		margin-right: 10px;
		position: absolute;
		top: 16px;
		left: 18px;
	}

	.info-box {
		padding-bottom: 30px;
	}
</style>
